
import React, { Component } from 'react'
import { connect } from 'react-redux'
import './timelineSlidePanel.scss'

// elements
import SlidePanel from '../../../elements/slidePanel'
import { CapacityManagementIcons } from '../../../elements/icons'
import IconAccordion from '../../../elements/iconAccordion'
import CloseButton from '../../../elements/closeButton'
import Avatar from '../../../elements/avatar'
// import Inline from '../../../elements/inline'
// import Panel from '../../../elements/panel'
// import Label from '../../../elements/label'
// import Grid from '../../../elements/grid'

// Actions
import { closeSlidePanel } from '../../../../actions/common'
import { getOrderTimeline } from '../../../../actions/calendarOverview'
import { translation } from '../../../../utils/helpers'
// import { renderFullDate } from '../../../../utils/time'

// components
import TimeLineStep from './TimeLineStep'
import Button from '../../../elements/button'
// import Inline from '../../../elements/inline'
import FileArea from '../../../components/FileArea'
// import UserInfo from '../../../components/UserInfo'
import Notes from '../../../components/Notes'
// import LabelWrapper from '../../../elements/labelWrapper'
// import PanelHeader from '../../../elements/panelHeader'

class TimelineSlidePanel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      orderTimeline: undefined
    }
    this.closeTimeLineSlidePanel = this.closeTimeLineSlidePanel.bind(this)
  }

  componentDidMount (props) {
  }

  componentDidUpdate (prevProps) {
    if (this.props.orderId !== undefined && this.props.orderId !== null && this.props.orderId !== prevProps.orderId) {
      this.props.getOrderTimeline(this.props.orderId, this.props.currentTime || new Date()).then((res) => {
        this.setState({
          orderTimeline: res.data
        })
      })
    }
  }

  closeTimeLineSlidePanel () {
    if (this.props.onClose) this.props.onClose()
    this.setState({
      orderTimeline: undefined
    }, () => {
      this.props.closeSlidePanel('orderTimeline')
    })
  }

  renderTop () {
    let { OrderId, RegNr, Model, BrandName, Color } = this.state.orderTimeline

    let carIdentity = RegNr
    if (carIdentity === null || carIdentity === '') carIdentity = Model
    if (carIdentity === null || carIdentity === '') carIdentity = OrderId

    let carInfo = `${BrandName} ${Model}`.trim()
    if (carInfo !== null && carInfo !== '' && Color !== null && Color !== '') carInfo += ` - ${Color}`
    else if (carInfo === null || carInfo === '') carInfo = Color || ''

    return (
      <div className='header top' key={'top'}>
        <h1 className='title'>{carIdentity}</h1>
        <h3 className='sub-title'>{carInfo.toUpperCase()}</h3>
        <div className='close title-right'>
          <CloseButton onClick={this.closeTimeLineSlidePanel} />
        </div>
      </div>
    )
  }

  renderContent () {
    const renderEmployees = () => {
      let employees = this.state.orderTimeline.EmployeeAssignments
      let hasUnassigned = this.state.orderTimeline.HasUnassignedSteps
      if (!Array.isArray(employees)) return null

      let accordionComponents = employees.map(x => { return {customComponent: Avatar, initials: x.Initials, noCircle: true} })

      if (hasUnassigned) {
        accordionComponents.push({ icon: CapacityManagementIcons.Warning_assign, size: 'm', noCircle: true })
      }
      let firstEmployeeName = null
      let additionalEmployeeCount = employees.length - 1
      if (employees.length > 0) {
        firstEmployeeName = employees.slice(0, 1)[0].Name
      }

      return (
        <div className='employees' key='employees'>
          <IconAccordion icons={accordionComponents} size='m' />
          {!hasUnassigned && firstEmployeeName !== null && <span className='employee-name'>{firstEmployeeName}</span>}
          {!hasUnassigned && additionalEmployeeCount > 0 && <span className='employee-additional'>{'+ ' + additionalEmployeeCount}</span>}
          {hasUnassigned && <span className='employee-issue'>{translation(17911)}</span>}
        </div>
      )
    }

    return (
      <div className='content timeline' key={'content'}>
        {renderEmployees()}
        <div className='timelineContent'>
          <div className='timelineTitle'>
            <div className='process'>{translation(359)}</div>
            <div className='assessment'>{translation(17928)}</div>
            <div className='available'>{translation(1780)}</div>
          </div>
          {this.state.orderTimeline.TimelineSteps.map((x, index) => { return <TimeLineStep step={x} orderTimeLine={this.state.orderTimeline} key={index} /> })}
        </div>
      </div>
    )
  }

  renderBottom () {
    const workCardOnClick = () => {
      if (this.props.orderId !== -1) {
        this.props.openWorkcard('/orders/' + this.props.orderId)
      }
    }
    return (
      <div className='totals-sticky' key={'bottom'}>
        <Button size='m' style={'link'} spacing={0} labelText={159} onClick={workCardOnClick.bind(this)} />
        <div className='process'><span>{translation(470)}</span></div>
        <div className='assessment'><span>{this.state.orderTimeline.TotalTimeAssessment}</span></div>
        <div className='available'><span>{this.state.orderTimeline.TotalTimeAvaliable}</span></div>
      </div>
    )
  }

  renderTimeline () {
    let orderTimeline = this.state.orderTimeline
    if (orderTimeline === undefined) return null

    return [this.renderTop(), <div className='content' key='content-wrap'>{[this.renderContent(), this.renderBottom(), this.renderOrderNotesAndImages()]}</div>]
  }

  renderOrderNotesAndImages () {
    if (!this.state.orderTimeline) return null
    let { OrderFiles, Notes: orderNotes } = this.state.orderTimeline

    return (
      <div className='notes-files' key='notes'>
        <div>
          <div className='title'>{`${translation(14834)} (${orderNotes ? orderNotes.length : 0})`}</div>
          <Notes notes={orderNotes} inline />
        </div>
        <div>
          <div className='title'>{translation(1043)}</div>
          <FileArea otherFiles={OrderFiles.filter(x => !x.IsImage)} images={OrderFiles.filter(x => x.IsImage)} auth={this.props.auth} />
        </div>
      </div>
    )
  }

  render () {
    return (
      <div className='timelineSlidePanel'>
        <SlidePanel slidePanelId='orderTimeline'>
          {this.renderTimeline()}
        </SlidePanel>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  closeSlidePanel,
  getOrderTimeline
})(TimelineSlidePanel)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/OrderCapacityOverview/TimelineSlidePanel/index.js